module.exports = __webpack_public_path__ + "img/f480482b-cfab-41c6-9488-792a879e1878.5c2e43b5.jpg";